// HotelRefreshBoundary.jsx
import { useSelector } from "react-redux";

const HotelRefreshBoundary = ({ children }) => {
  const hotelId = useSelector(state => state.hotel.hotelId);

  return (
    <div key={hotelId}>
      {children}
    </div>
  );
};

export default HotelRefreshBoundary;
